import reduceReducers from "reduce-reducers";

import { TRADING_TERM } from "constants/actionTypes";

import {
  apiModelOfflineFetchReducer,
  deploymentNestedArrayReducer,
} from "lib/reducers";
import { deserializeTradingTerm as deserializer } from "lib/serializers/tradingTerms";

const deploymentReducer = deploymentNestedArrayReducer({
  arrayField: "trading_terms",
  injectField: "deployment_id",
  parentIdField: "deploymentId",
  deserializer,
});

const fetch = apiModelOfflineFetchReducer(TRADING_TERM, {
  deserializer,
});

const tradingTermsReducer = reduceReducers(fetch, deploymentReducer);

export default tradingTermsReducer;
